var _path, _path2, _g, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdRevival(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_82)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_77_82",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0H0V25H25V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2647 23.6766C21.7012 23.6766 23.6764 21.7013 23.6764 19.2648C23.6764 16.8282 21.7012 14.853 19.2647 14.853C16.8281 14.853 14.8529 16.8282 14.8529 19.2648C14.8529 21.7013 16.8281 23.6766 19.2647 23.6766Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_77_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41175 2.94116H13.6029L18.0147 7.35293V17.2794H9.55881C9.55881 17.6694 9.40387 18.0435 9.12808 18.3193C8.8523 18.595 8.47825 18.75 8.08822 18.75H4.41175C4.02173 18.75 3.64768 18.595 3.37189 18.3193C3.0961 18.0435 2.94116 17.6694 2.94116 17.2794V4.41175C2.94116 4.02173 3.0961 3.64768 3.37189 3.37189C3.64768 3.0961 4.02173 2.94116 4.41175 2.94116Z",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98523 7.55884H12.8676V13.4412H6.98523V7.55884Z",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98523 9.39697H12.8676",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98523 11.603H12.8676",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82349 7.55884V13.4412",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0294 7.55884V13.4412",
    stroke: "#000"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2647 23.0882C21.3764 23.0882 23.0882 21.3764 23.0882 19.2647C23.0882 17.153 21.3764 15.4412 19.2647 15.4412C17.153 15.4412 15.4412 17.153 15.4412 19.2647C15.4412 21.3764 17.153 23.0882 19.2647 23.0882Z",
    stroke: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7941 17.7942L20.7352 20.7354",
    stroke: "#000",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7352 17.7942L17.7941 20.7354",
    stroke: "#000",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdRevival);
export default __webpack_public_path__ + "static/media/pd_revival.39b9b74c5284c057fea174c0a15b9ff4.svg";
export { ForwardRef as ReactComponent };